<template>
  <bim-input
    width="100%"
    :value="value"
    @input="v => $emit('input', v)"
    :placeholder="placeholder"
    formKey="value"
    :formModel="_self"
    @blur="validate"
    height="100%"
    style="width: 100%"
    class="flex-grow-1"
  />
</template>

<script>
import validationMixin from '../validation.mixin'
import bimInput from '@/components/form/bimInput/bimInput'
export default {
  name: 'FieldInput',
  mixins: [validationMixin],
  components: {
    bimInput
  },
  props: {
    value: String,
    placeholder: String,
  }
}
</script>
